import React from 'react';
import Icon from '../../../components/AppIcon';
import Select from '../../../components/ui/Select';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';

const JobFilters = ({ filters, onFilterChange, onClearFilters }) => {
  const workTypeOptions = [
    { value: 'all', label: 'Alle types' },
    { value: 'solar', label: 'Zonnepanelen' },
    { value: 'heatpump', label: 'Warmtepompen' },
    { value: 'battery', label: 'Thuisbatterijen' },
    { value: 'maintenance', label: 'Technisch onderhoud' },
    { value: 'ventilation', label: 'Ventilatie systemen' }
  ];

  const locationOptions = [
    { value: 'all', label: 'Alle locaties' },
    { value: 'amsterdam', label: 'Amsterdam' },
    { value: 'rotterdam', label: 'Rotterdam' },
    { value: 'utrecht', label: 'Utrecht' },
    { value: 'den-haag', label: 'Den Haag' },
    { value: 'eindhoven', label: 'Eindhoven' }
  ];

  const budgetRangeOptions = [
    { value: 'all', label: 'Alle budgetten' },
    { value: '0-1000', label: '€0 - €1.000' },
    { value: '1000-2500', label: '€1.000 - €2.500' },
    { value: '2500-5000', label: '€2.500 - €5.000' },
    { value: '5000-10000', label: '€5.000 - €10.000' },
    { value: '10000+', label: '€10.000+' }
  ];

  const statusOptions = [
    { value: 'all', label: 'Alle statussen' },
    { value: 'open', label: 'Openstaand' },
    { value: 'ongoing', label: 'In uitvoering' },
    { value: 'completed', label: 'Voltooid' }
  ];

  const hasActiveFilters = 
    filters?.workType !== 'all' || 
    filters?.location !== 'all' || 
    filters?.budgetRange !== 'all' || 
    filters?.status !== 'all' ||
    filters?.searchQuery !== '';

  return (
    <div className="bg-card border border-border rounded-lg p-4 md:p-5 lg:p-6 mb-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="font-heading font-semibold text-base md:text-lg text-foreground flex items-center gap-2">
          <Icon name="Filter" size={20} />
          Filters
        </h3>
        {hasActiveFilters && (
          <Button
            variant="ghost"
            size="sm"
            onClick={onClearFilters}
            iconName="X"
            iconSize={16}
          >
            Wis filters
          </Button>
        )}
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        <Input
          type="search"
          placeholder="Zoek opdrachten..."
          value={filters?.searchQuery}
          onChange={(e) => onFilterChange('searchQuery', e?.target?.value)}
          className="w-full"
        />

        <Select
          options={workTypeOptions}
          value={filters?.workType}
          onChange={(value) => onFilterChange('workType', value)}
          placeholder="Selecteer type"
        />

        <Select
          options={locationOptions}
          value={filters?.location}
          onChange={(value) => onFilterChange('location', value)}
          placeholder="Selecteer locatie"
        />

        <Select
          options={budgetRangeOptions}
          value={filters?.budgetRange}
          onChange={(value) => onFilterChange('budgetRange', value)}
          placeholder="Selecteer budget"
        />
      </div>
      <div className="mt-4">
        <Select
          options={statusOptions}
          value={filters?.status}
          onChange={(value) => onFilterChange('status', value)}
          placeholder="Selecteer status"
          className="w-full md:w-64"
        />
      </div>
    </div>
  );
};

export default JobFilters;